import React from "react";
import Seo from "../components/Seo";
import { PageHero, ReferralForm } from "../components/Shared";
import { CONTACT } from "../mock";
import { Phone, Printer, Mail, Clock, ShieldCheck, ClipboardList } from "lucide-react";

const BASE = "https://carefirstoh.com";
const steps = [
  { icon: ClipboardList, title: "1. Send the Referral", text: "Complete the form, call, or fax patient details and any physician orders." },
  { icon: ShieldCheck, title: "2. Eligibility & Assessment", text: "We verify insurance/program coverage and schedule a home assessment." },
  { icon: Clock, title: "3. Care Begins", text: "We build a personalized care plan and begin services promptly." },
];

const Referral = () => (
  <div>
    <Seo title="Make a Referral | CareFirst Home Health, Columbus OH" description="Refer a patient to CareFirst Home Health in Columbus, Ohio. We welcome referrals from physicians, hospitals, discharge planners, social workers and case managers." canonical={BASE + "/referral"} />
    <PageHero title="Make a Referral" subtitle="We welcome referrals from physicians, hospitals, discharge planners, social workers, case managers, families, and other healthcare professionals." crumbs={[{ label: "Home", to: "/" }, { label: "Make a Referral" }]} />

    <section className="bg-white py-16">
      <div className="max-w-[1240px] mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {steps.map((s) => (
            <div key={s.title} className="rounded-2xl border border-gray-100 shadow-sm p-7">
              <div className="w-14 h-14 rounded-full bg-[#eef6ea] flex items-center justify-center mb-4"><s.icon size={26} className="text-[#4ca82f]" /></div>
              <h3 className="font-display text-[#16357a] text-[20px] font-semibold mb-2">{s.title}</h3>
              <p className="text-[#666] text-[14px] leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2 bg-[#eef6ea] rounded-2xl p-7 md:p-9">
            <h2 className="font-display text-[#16357a] text-[28px] font-semibold mb-2">Referral Form</h2>
            <p className="text-[#666] text-[14px] mb-6">Complete the secure form below. All fields marked * are required.</p>
            <ReferralForm />
          </div>
          <aside className="space-y-6">
            <div className="bg-[#16357a] text-white rounded-2xl p-7">
              <h3 className="font-display text-[24px] font-semibold mb-4">Other Ways to Refer</h3>
              <ul className="space-y-4 text-[15px]">
                <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center"><Phone size={18} className="text-[#7ed957]" /></span><div><div className="text-white/70 text-[12px]">Phone</div>{CONTACT.phone}</div></li>
                <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center"><Printer size={18} className="text-[#7ed957]" /></span><div><div className="text-white/70 text-[12px]">Fax</div>{CONTACT.fax}</div></li>
                <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center"><Mail size={18} className="text-[#7ed957]" /></span><div><div className="text-white/70 text-[12px]">Email</div>{CONTACT.email}</div></li>
              </ul>
            </div>
            <div className="bg-white border border-gray-100 shadow-sm rounded-2xl p-7">
              <h3 className="font-display text-[#16357a] text-[20px] font-semibold mb-3">Programs Accepted</h3>
              <div className="flex flex-wrap gap-2">
                {["Medicare", "Medicaid", "PASSPORT", "DODD", "VA", "Managed Care"].map((p) => <span key={p} className="px-3 py-1.5 rounded-full bg-[#eef6ea] text-[#16357a] font-semibold text-[13px]">{p}</span>)}
              </div>
              <p className="text-[#666] text-[13px] mt-4 leading-relaxed">We aim to respond to all referrals promptly, with priority for hospital discharges.</p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  </div>
);

export default Referral;
